import { motion } from 'framer-motion';

interface AboutSectionProps {
  onRegisterClick: () => void;
}

export default function AboutSection({ onRegisterClick }: AboutSectionProps) {
  return (
    <section className="py-24 px-6 bg-[#F8F7F4]">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-[#101A2E] mb-8 text-center" style={{ fontFamily: 'Manrope, sans-serif' }}>
            О чём школа
          </h2>
          
          <div className="space-y-6 text-[#1E2430] text-lg leading-relaxed text-justify">
            <p>
              <strong className="text-[#D8B36A]">«Петербуржские вечера»</strong> — это серия очных научно-практических встреч для врачей, которые проходят два раза в год в культурной столице нашей страны.
            </p>
            
            <p>
              Мы собираем врачей разных специальностей вокруг одной реальной клинической проблемы — <strong>коморбидности</strong>, когда у одного пациента переплетаются боль, сосудистые риски, когнитивные нарушения, эндокринные и ревматологические компоненты.
            </p>

            <div className="pt-8 text-center">
              <button
                onClick={onRegisterClick}
                className="px-8 py-4 bg-[#D8B36A] text-[#101A2E] rounded-lg font-bold text-base hover:bg-[#C9A459] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Присоединиться к встрече
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}